import React from 'react';
import { LineChart, Line, Tooltip } from 'recharts';
import '../styles/Hero.css';
import {Link} from "react-router-dom";

const Hero = () => {
    const data = Array.from({ length: 41 }, (_, i) => {
        const x = i - 10;
        return { x, y: x * x };
    });

    return (
        <div className="hero">
            <div className="hero-content">
                <h1>Leading the Curve with Analytics</h1>
                <p>Empowering decisions that drive results.</p>
                <div className="cta-buttons">
                    <Link to="/contact"><button className="btn-primary">Get Started</button></Link>
                    <Link to="/services"><button className="btn-secondary">Learn More</button></Link>
                </div>
            </div>
            <div className="curve-plot">
                <LineChart
                    width={600}
                    height={300}
                    data={data}
                    margin={{ top: 10, right: 30, bottom: 0, left: 0 }}
                >
                    <Tooltip active={false}/>
                    <Line type="monotone" dataKey="y" stroke="#EE4266" dot={false} activeDot={{ r: 6, fill: '#FF4500' }} />
                </LineChart>
            </div>

        </div>
    );
};

export default Hero;
